import BackendAPI from '~/api/BackendClient/BackendAPI'
import { components } from '~/api/BackendClient/generated-schema'

export type BulkExportCultureMetadataRequest =
  components['schemas']['BulkExportCultureMetadataRequest']

export type BulkExportCultureMetadataResponse =
  components['schemas']['BulkExportCultureMetadataResponse']

export type BulkExportCultureMetadata_CulturePlate =
  components['schemas']['BulkExportCultureMetadata_CulturePlate']

class BulkExportCultureMetadataAPI extends BackendAPI {
  getData = (
    request: BulkExportCultureMetadataRequest,
  ): Promise<BulkExportCultureMetadataResponse> => {
    return this.client.POST('/api/pages/bulk-export-culture-metadata/', {
      body: request,
    })
  }
}

export default BulkExportCultureMetadataAPI
